import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ProtectedRoute = ({ children, moduleName }) => {
  const { user, token, loading } = useContext(AuthContext);

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Cargando...</div>;
  }

  if (!token) {
    return <Navigate to="/login" />;
  }

  // Si se requiere un módulo específico, verificar si el usuario lo tiene
  if (moduleName && user) {
    // Superadmin tiene acceso a todo
    if (user.role === 'superadmin') return children;

    const hasAccess = user.modules?.some(m => m.name === moduleName);
    if (!hasAccess) {
      return <Navigate to="/welcome" />;
    }
  }

  return children;
};

export default ProtectedRoute;
